@if (showMissingCategoryWarning) {
  <section class="vc-admin-form vc-admin-treatment-form vc-admin-form--category-warning">
    @if (showIntro) {
      <header class="vc-admin-form__intro">
        <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
        <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
      </header>
    }

    <section class="vc-admin-form__section">
      <div class="vc-admin-form__warning">
        <i class="fas fa-triangle-exclamation"></i>
        <p>{{ "ADMIN.FORMS.TREATMENT.CATEGORY_REQUIRED" | translate }}</p>
      </div>

      <a
        [routerLink]="['/administration', customer_route_param, 'treatments', 'categories', 'new']"
        class="vc-admin-form__category-link"
      >
        {{ "ADMIN.FORMS.TREATMENT.CREATE_CATEGORY_ACTION" | translate }}
      </a>
    </section>
  </section>
} @else {
  <form class="vc-admin-form vc-admin-treatment-form" (ngSubmit)="execute()">
    @if (showIntro) {
      <header class="vc-admin-form__intro">
        <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
        <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
      </header>
    }

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.TREATMENT" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.TREATMENT.DETAIL_HINT" | translate }}
    </p>

    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="treatment-name">{{ "COMMON.TREATMENT.NAME" | translate }} *</label>
          <input
            id="treatment-name"
            pInputText
            pSize="small"
            name="name"
            [(ngModel)]="payload.name"
            fluid
          />
          <small class="p-error" *ngIf="errors.name">{{ errors.name | translate }}</small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="treatment-category">{{ "COMMON.TREATMENT.CATEGORY" | translate }}</label>
          <p-select
            id="treatment-category"
            name="category"
            [options]="treatmentsCategories"
            [(ngModel)]="payload.treatments_categories_id"
            optionLabel="name"
            optionValue="id"
            appendTo="body"
            size="small"
            fluid
          ></p-select>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="treatment-duration">
            {{ "COMMON.DURATION" | translate }} ({{ "COMMON.MINUTES" | translate }}) *
          </label>
          <p-inputnumber
            inputId="treatment-duration"
            name="duration_minutes"
            [min]="5"
            [max]="720"
            [step]="5"
            [(ngModel)]="payload.duration_minutes"
            size="small"
            fluid
          />
          <small class="vc-admin-form__hint">
            {{ "ADMIN.FORMS.TREATMENT.DURATION_HINT" | translate }}
          </small>
          <small class="p-error" *ngIf="errors.duration_minutes">
            {{ errors.duration_minutes | translate }}
          </small>
        </div>
      </div>

      <div class="col-12">
        <div class="field">
          <label for="treatment-description">{{ "COMMON.TREATMENT.DESCRIPTION" | translate }}</label>
          <input
            id="treatment-description"
            pInputText
            pSize="small"
            name="description"
            [(ngModel)]="payload.description"
            fluid
          />
          <small class="p-error" *ngIf="errors.description">
            {{ errors.description | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.COLOR" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.TREATMENT.COLOR_HINT" | translate }}
    </p>

    <div class="field">
      <label for="treatment-color">{{ "COMMON.TREATMENT.COLOR" | translate }}</label>
      <div class="vc-admin-color-control">
        <div class="vc-admin-color-control__inputs">
          <input
            id="treatment-color"
            class="vc-admin-color-control__picker"
            type="color"
            [value]="colorPreview"
            (input)="onColorInput($any($event.target).value)"
          />
          <input
            pInputText
            [value]="colorPreview"
            (input)="onColorInput($any($event.target).value)"
          />
        </div>
        <div class="vc-admin-color-control__presets">
          @for (preset of colorPresets; track preset) {
            <button
              type="button"
              class="vc-admin-color-control__preset"
              [class.is-active]="preset === colorPreview"
              [style.background]="preset"
              [attr.aria-label]="('COMMON.COLOR' | translate) + ' ' + preset"
              (click)="selectColorPreset(preset)"
            ></button>
          }
        </div>
      </div>
      <small class="vc-admin-color-control__hint">
        {{ "ADMIN.FORMS.TREATMENT.COLOR_HINT" | translate }}
      </small>
      <small class="p-error" *ngIf="errors.color">{{ errors.color | translate }}</small>
    </div>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ "COMMON.PRICE.BASE" | translate }}</h4>
    <p class="vc-admin-form__section-subtitle">
      {{ "ADMIN.FORMS.TREATMENT.PRICE_HINT" | translate }}
      <strong *ngIf="basePriceCurrencyLabel"> ({{ basePriceCurrencyLabel }})</strong>
    </p>

    <div class="field">
      <label for="treatment-base-price">
        {{ "COMMON.PRICE.BASE" | translate }}
        <span *ngIf="basePriceCurrencyLabel">({{ basePriceCurrencyLabel }})</span>
        *
      </label>
      <p-inputnumber
        inputId="treatment-base-price"
        name="basePrice"
        size="small"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [(ngModel)]="payload.basePrice"
        fluid
      />
    </div>
    <small class="p-error" *ngIf="errors.basePrice">{{ errors.basePrice | translate }}</small>
  </section>

  @if (mode === 'create') {
    <section class="vc-admin-form__section">
      <h4 class="vc-admin-form__section-title">{{ "ADMIN.FORMS.ASSIGNMENT.TITLE" | translate }}</h4>
      <p class="vc-admin-form__section-subtitle">
        {{ "ADMIN.FORMS.ASSIGNMENT.SUBTITLE" | translate }}
      </p>

      <div class="vc-admin-form__warning">
        <i class="fas fa-triangle-exclamation"></i>
        <p>{{ "ADMIN.FORMS.ASSIGNMENT.WARNING" | translate }}</p>
      </div>

      <div class="vc-admin-assignment-options">
        <label class="vc-admin-assignment-options__item" for="treatment-save-manual">
          <p-radioButton
            inputId="treatment-save-manual"
            name="treatmentSaveMode"
            value="manual"
            [(ngModel)]="saveMode"
          />
          <span>
            <strong>{{ "ADMIN.FORMS.ASSIGNMENT.MANUAL_TITLE" | translate }}</strong>
            <small>{{ "ADMIN.FORMS.ASSIGNMENT.MANUAL_DESCRIPTION" | translate }}</small>
          </span>
        </label>

        <label class="vc-admin-assignment-options__item" for="treatment-save-all">
          <p-radioButton
            inputId="treatment-save-all"
            name="treatmentSaveMode"
            value="all-clinics"
            [(ngModel)]="saveMode"
          />
          <span>
            <strong>{{ "ADMIN.FORMS.ASSIGNMENT.ALL_TITLE" | translate }}</strong>
            <small>{{ "ADMIN.FORMS.ASSIGNMENT.ALL_DESCRIPTION" | translate }}</small>
          </span>
        </label>
      </div>
    </section>
  }

    <app-admin-form-actions
      primaryLabelKey="COMMON.SAVE"
      [submitting]="submitting"
    ></app-admin-form-actions>
  </form>
}
